<template>
    <div
        v-click-outside="hide"
        class="notifications"
    >
        <div
            class="notifications__button"
            data-voicetext="Уведомления"
            :class="{ notifications__button_state_active: isOpen }"
            @click="toggle"
        >
            <BellIcon
                class="bell-icon"
            />

            <div
                class="notifications__new"
                v-if="newNotifications > 0"
            ></div>
        </div>

        <div
            v-if="isOpen"
            class="notifications__feed"
            :style="{ 'min-height': isMobile ? `calc(${height}px - 15rem)` : null }"
            @click.stop
        >
            <div class="notifications__feed__header">
                <h2>Уведомления</h2>
                <div
                    class="clear"
                    v-if="notifications.length > 0"
                    @click="deleteAllNotifications"
                >Удалить все</div>
            </div>

            <div
              class="notifications__feed__items"
              :style="{ 'max-height': isMobile ? `calc(${height}px - 25.2rem)` : null }"
            >
                <NotificationBasic
                    class="border"
                    v-for="item in items"
                    :key="item.id"
                    :value="item"
                    :swipe.sync="swipeItemId"
                    @remove="onRemove(item)"
                />
            </div>

            <div
                v-if="!is_collapsed && limit && notifications.length > limit"
                class="display_all"
                @focus="isOpen = true"
                @click="limit = null"
            >Показать все</div>

            <div
                v-if="notifications.length === 0"
                class="notifications__feed__footer"
            >Ничего нового</div>
        </div>
    </div>
</template>

<script>
import BellIcon from "../../assets/images/icons/bell.svg?inline";
import { mapGetters, mapActions } from 'vuex';
import NotificationBasic from './notifications/Basic';

const getters = [
    'is_collapsed',
    'notifications',
    'newNotifications',
    'isMobile',
    'height',
];

const actions = [
    'lockBody',
    'readNotifications',
    'deleteNotification',
    'deleteAllNotifications',
    'loadNotifications',
];

const defaultLimit = 3;

export default {
    name: 'Notifications',
    components: {
        NotificationBasic,
        BellIcon,
    },
    data: () => ({
        isOpen: false,
        limit: defaultLimit,
        swipeItemId: null,
    }),
    computed: {
        ...mapGetters(getters),
        items() {
            if (!this.isOpen) {
                return [];
            } else if (!this.limit || this.is_collapsed) {
                return this.notifications;
            } else {
                return this.notifications.slice(0, this.limit);
            }
        },
    },
    methods: {
        ...mapActions(actions),
        hide() {
            this.isOpen = false;
        },
        toggle() {
            this.isOpen = !this.isOpen;
        },
        onRemove(item) {
            this.deleteNotification(item.id);
        },
    },
    watch: {
        isOpen(v) {
            if (!v) {
                this.limit = defaultLimit;
            }

            if (this.is_collapsed) {
                this.lockBody(v);
            }
        },
    },
    mounted() {
        this.loadNotifications();
        // костыль для версии слабовидащих
        // var vm = this;
        // document.addEventListener('click', function (e) {
        //     if(e.target.className !== 'noty-button active') {
        //         vm.hide();
        //     }
        // });
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';

.notifications {
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &__button {
        cursor: pointer;
        color: var(--color-primary);

        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            color: var(--color-primary);
        }

        .bell-icon {
            width: mrem(24);
            height: mrem(24);

            @include on-desktop {
                width: rem(24);
                height: rem(24);
            }
        }
    }

    &__new {
        position: absolute;
        font-size: 0.7rem;
        color: white;
        background: #D1004A;
        padding: 0.2rem;
        border-radius: 50%;
        width: mrem(8);
        height: mrem(8);
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        @include on-desktop {
            width: rem(10);
            height: rem(10);
            top: rem(-3);
        }
    }

    &__feed {
        cursor: default;
        position: fixed;
        width: 100%;
        top: mrem(60);
        left: 0;
        z-index: 2;
        background: #fff;
        box-shadow: 0 mrem(2) mrem(16) rgba(155, 161, 166, 0.25);
        backdrop-filter: blur(mrem(16));
        border-radius: mrem(4);
        margin: 0;

        @include on-desktop {
            position: absolute;
            width: rem(400);
            top: rem(35);
            right: 0;
            left: unset;
            box-shadow: 0 rem(2) rem(16) rgba(155, 161, 166, 0.25);
            backdrop-filter: blur(rem(16));
            border-radius: rem(4);
        }

        &__header {
            user-select: none;
            padding: rem(16) rem(16) rem(16) rem(24);
            border-bottom: 1px solid #E4E6E5;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            @include on-sm {
                padding: smrem(11) smrem(24) smrem(12) smrem(16);
            }

            @include on-xs {
                padding: xsrem(11) xsrem(24) xsrem(12) xsrem(16);
            }
            @include on-uxs {
                padding: xsrem(11) uxsrem(24) uxsrem(12) uxsrem(16);
            }

            h2 {
                font-family: "Montserrat", sans-serif;
                font-weight: 600;
                font-size: rem(16);
                line-height: rem(20);
                text-align: left;
                color: #2A2626;
                margin: 0;

                @include on-xs {
                    font-size: xsrem(14);
                    line-height: xsrem(17);
                    color: #4663AB;
                }
                @include on-uxs {
                    font-size: uxsrem(14);
                    line-height: uxsrem(17);
                    color: #4663AB;
                }
            }


            .clear {
                cursor: pointer;
                display: block;
                font-weight: 600;
                font-size: rem(12);
                line-height: rem(20);
                color: #4663AB;

                @include on-xs {
                    display: none;
                }
                @include on-uxs {
                    display: none;
                }
            }
        }

        &__items {
            max-height: rem(700);
            overflow-y: auto;
            overflow-x: hidden;

            @include custom-scroll-bar;
        }

        &__footer {
            padding: rem(16) rem(16) rem(16) rem(24);
            text-align: center;
            font-family: "Open Sans", sans-serif;
            font-size: rem(14);
            line-height: rem(20);
            color: #98A0A9;
            vertical-align: middle;

            @include on-xs {
                padding: xsrem(16) xsrem(16) xsrem(16) xsrem(24);
                font-size: xsrem(14);
                line-height: xsrem(20);
            }
            @include on-uxs {
                padding: uxsrem(16) uxsrem(16) uxsrem(16) uxsrem(24);
                font-size: uxsrem(14);
                line-height: uxsrem(20);
            }
        }
    }
    .border {
        border-bottom: 1px solid #E4E6E5;

        &:last-of-type {
            @include on-desktop {
                border-bottom: none;
            }
        }
    }

    .display_all {
        font-weight: 700;
        font-size: mrem(16);
        line-height: mrem(20);
        padding: mrem(14) 0;
        background: #4663AB;
        color: #FFFFFF;
        text-align: center;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(20);
            padding: rem(14) 0;
            cursor: pointer;
        }
    }
}

</style>

